/**
 * Why the user was sent to the language selector, forwarded by
 * `entryLanguageGuard` via the `reason` query param and reflected in the
 * selector's info text.
 *
 * This lives in its own file, not next to `LocalizationSelectorComponent`:
 * the producer (`entryLanguageGuard`) is eagerly loaded on the `:language`
 * route while the selector is a `loadComponent` chunk, so importing the enum
 * from the component would drag the component and its Material imports into
 * the eager bundle.
 */
export enum SelectorReason {
  /** External deep link and no stored language preference (Case A). */
  External = 'external',
  /** The target document is not available in the stored preference (Case B). */
  Unavailable = 'unavailable',
  /**
   * The reader asked to change language while a document was open (the
   * toolbar's `?force=true` link). Unlike the two cases above the document
   * *is* available in the stored preference, so the selector must be shown
   * rather than silently resolved — and the preference is deliberately kept,
   * so the reader can back out to the document they came from.
   */
  Switch = 'switch',
}
